<template lang="pug">
div.items-list
  infinity-scroll(
    :hasNextPage="canLoadMore"
    @scrolling="onLoadMore"
    :loading="loading"
  )
    v-data-table(
      v-model="activeItems"
      :headers="headers"
      :items="list"
      item-key="id"
      hide-default-footer
      multi-sort=multiSort
      :disable-sort="disableSorting"
      :sort-by.sync="sortModel.by"
      :sort-desc.sync="sortModel.desc"
      @update:sort-desc="updateSorting"
      :server-items-length="list.length"
      :single-select="false"
      :loading="loading"
      :show-select="!hideSelect"
      class="app-table elevation-1"
      ref="sortableTable"
      id="test"
    )
      template(v-if="activeItems.length" v-slot:top)
        .d-flex.pa-3.align-center
          div {{activeItems.length}} items selected
          v-btn(
            @click="showDeleteConfirmationModal(activeItems)"
            icon
            small
          ).ml-auto
            v-icon(color="primary") mdi-delete
      template(v-slot:item="{item, select, isSelected, index}")
        tr(
          :key="index"
          :active="isSelected"
        ).sortable-row
          td.px-3(v-if="!hideSelect")
            v-checkbox(hide-details v-model="isSelected" @change="select").mt-0
          slot(:item="item")
          td(v-if="!hideActions").text-center
            v-btn(icon small @click="itemEditClick(item)")
              v-icon(small) mdi-pencil
            v-btn(icon small @click="showDeleteConfirmationModal(item)")
              v-icon(small) mdi-delete

  confirmation-dialog(
      v-model="deleteConfirmationModal"
      :title="deleteDialogTitle"
      @okBtnClicked="deleteItem"
  )
</template>

<script>
import Sortable from 'sortablejs';
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    multiSort: {
      type: Boolean,
      default: true
    },
    pagination: Object,
    loading: Boolean,
    sortModel: {
      type: Object,
      default: () => ({}),
    },
    disableSorting: Boolean,
    hideActions: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      required: true,
    },
    hideSelect: {
      type: Boolean,
      default: false,
    },
    deleteDialogTitle: {
      type: String,
      default: 'Are you sure to delete this item?'
    }
  },
  watch: {
    pagination(val) {
      this.page = 1;
    },
    list: {
      immediate: true,
      handler(list) {
        this.listIds = list.map(listItem => listItem.id);
      }
    }
  },
  updated() {
    if (this.$refs.sortableTable && !this.sortInitiated) {
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortable-row',
          handle: '.sortable-row',
          onEnd: this.dragReorder
        }
      )
      this.sortInitiated = true;
    }

  },
  computed: {
    canLoadMore() {
      if (this.pagination) {
        return !this.loading && this.pagination.count > this.list.length;
      }
      return false;
    }
  },
  data: () => ({
    activeItems: [],
    deletingItem: null,
    sortBy: [],
    sorting: [],
    listIds: [],
    deleteConfirmationModal: false,
    page: 1,
    sortInitiated: false,
  }),

  methods: {
    dragReorder({oldIndex, newIndex}) {
      const movedItem = this.listIds.splice(oldIndex, 1)[0];
      this.listIds.splice(newIndex, 0, movedItem);
      this.$emit('onReorder', this.listIds);
    },
    showDeleteConfirmationModal(item) {
      this.deleteConfirmationModal = true
      this.deletingItem = item
    },

    itemEditClick(item) {
      this.$emit('itemEditClick', item)
    },

    deleteItem() {
      this.$emit('removeClicked', this.deletingItem)
      this.deletingItem = null
      this.activeItems = [];
    },

    async onLoadMore() {
      this.page += 1;
      this.$emit('loadMoreClick', this.page);
    },

    async updateSorting() {
      let data = this.sortModel.getApiData(this.$route.query)
      let ordering
      if(data.ordering.length) ordering = data.ordering
      await this.$router.replace({ query: { ...this.$route.query, ordering: ordering}})
      this.$emit('sortChanged')
    },
  },
  components: {
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue'),
    popoverForm: () => import('@/components/global/PopoverForm.vue'),
    check: () => import('@/components/global/CheckBoolean.vue'),
    infinityScroll: () => import('@/components/global/infinityScroll.vue')
  }
}
</script>
<style lang="scss" scoped>
.items-list {
  overflow: hidden;
  height: 100%;
  .v-data-table::v-deep {
    .v-input--selection-controls {
      padding-top: 0;
      .v-input--selection-controls__input {
        margin-right: 0;
      }
    }
    .v-data-table__checkbox {
      text-align: center;
      padding: 0 8px;
    }
  }
  .v-input--checkbox::v-deep {
    .v-input__slot {
      justify-content: center;
    }
  }
  .infinity-scroll__container ::v-deep {
    height: 100%;
    > div {
      height: 100%!important;
      overflow-y: auto!important;
    }
  }
}
</style>
